export enum PropertyTypes {
  Boolean = 'boolean',
  Connection = 'connection',
  Integer = 'integer',
  DateTime = 'datetime',
  Date = 'date',
  Decimal = 'decimal',
  Document = 'document',
  Location = 'location',
  RichText = 'rich_text',
  Text = 'text',
  URL = 'url',
  IMAGE_URL = 'image_url',
  ENUM = 'enum',
}

export enum IsDefault {
  NAME = 'name',
}

export enum ConnectionPropertyTypes {
  TEXT = 'text',
  DATE = 'date',
  DATETIME = 'datetime',
  INTEGER = 'integer',
  DECIMAL = 'decimal',
  RICHTEXT = 'rich_text',
}
